import { AwaitContainer, Button, DialogRoot, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useKnowledgeNode } from '@/entities/knowledge';
import { useHasPermission } from '@/entities/profile';

type Props = {
  nodeId?: number;
  onClose: () => void;
};

export const KnowledgeNodeDetailDialog: FC<Props> = ({ nodeId, onClose }) => {
  const { t } = useTranslation(['dialogs']);
  const { data, isLoading } = useKnowledgeNode(nodeId);
  const canViewKnowledge = useHasPermission('VIEW_KNOWLEDGE');
  return (
    <DialogRoot open={!!nodeId} onOpenChange={(open: boolean) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{`${t('expertReport.knowledgeNodeTitle')}: ${data?.name ?? ''}`}</DialogTitle>
        </DialogHeader>
        <AwaitContainer isLoading={isLoading}>
          <div className="whitespace-pre-wrap text-sm">{data?.text}</div>
        </AwaitContainer>
        <DialogFooter className="flex items-center">
          {canViewKnowledge && (
            <Link to={`/knowledge/${nodeId}`} className="text-primary underline text-sm hover:text-primary/80">
              {t('expertReport.openCard')}
            </Link>
          )}
          <Button variant="outline" onClick={onClose}>
            {t('expertReport.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
